import { render, staticRenderFns } from "./IndexPayments.vue?vue&type=template&id=e72ffebe&"
import script from "./IndexPayments.vue?vue&type=script&lang=js&"
export * from "./IndexPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports